// extracted by mini-css-extract-plugin
module.exports = {"module":"NotesPanel_module__jtZNh","empty":"NotesPanel_empty__3AZfO"};